var map = {
	"./ca.json": "./src/assets/i18n/ca.json",
	"./en.json": "./src/assets/i18n/en.json",
	"./es.json": "./src/assets/i18n/es.json",
	"./pt.json": "./src/assets/i18n/pt.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/i18n sync recursive ^\\.\\/.*\\.json$";